import awsContainer from './Container.json';
import awsDropdown from './Dropdown.json';
import awsHeatmap from './HeatMap.json';

export default [
  awsContainer,
  awsDropdown,
  awsHeatmap,
  // ...
];
